import script from "./HomeLastWeekAssignments.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeLastWeekAssignments.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__